var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 0c-1.498 0-2.974.684-3.822 2.081 0 0-24.073 39.407-24.27 39.825a4.24 4.24 0 0 0-.408 1.8C0 46.092 2.003 48 4.342 48h48.316C54.998 48 57 46.093 57 43.706c0-.638-.15-1.25-.409-1.8-.195-.418-24.269-39.825-24.269-39.825C31.474.684 29.999 0 28.5 0Zm0 3.6c.33 0 .698.221.78.356 0 .006 24.043 39.4 24.102 39.507a.617.617 0 0 1 .056.243c0 .36-.289.694-.78.694H4.343c-.49 0-.779-.333-.779-.694 0-.09.025-.17.056-.244.059-.105 24.102-39.5 24.102-39.506.082-.135.45-.356.78-.356Zm0 10.2c-.986 0-1.78.803-1.78 1.8v15.6c0 .997.794 1.8 1.78 1.8.987 0 1.782-.803 1.782-1.8V15.6c0-.997-.795-1.8-1.782-1.8Zm0 22.8c-.986 0-1.78.803-1.78 1.8v1.2c0 .997.794 1.8 1.78 1.8.987 0 1.782-.803 1.782-1.8v-1.2c0-.997-.795-1.8-1.782-1.8Z",
    fill: "#5C7AFF"
  })));
};

export default SvgWarningIcon;